module.exports = __webpack_public_path__ + "static/media/ps-help-video-de.b5501ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/ps-help-video-de.png
// module id = 1468
// module chunks = 0